import type { Dictionary } from "@/lib/i18n/dictionaries/en";
import type { CatalogType } from "@/lib/site-catalog-types";

/**
 * Catalog API identifiers are stable kebab-case values; dictionary keys follow the
 * UI's camel-case convention. One mapping keeps the search page and Spotlight labels
 * identical without putting the server-only catalog in a client bundle.
 */
const CATALOG_TYPE_KEYS: Record<CatalogType, keyof Dictionary["catalogTypes"]> =
  {
    core: "core",
    "style-landing": "styleLanding",
    style: "style",
    "style-directory": "style",
    "style-examples": "styleExamples",
    "style-format": "styleFormat",
    "style-in-text": "styleInText",
    "style-annotated-bibliography": "styleAnnotatedBibliography",
    "style-reference-page": "styleReferencePage",
    tool: "tool",
    "tool-collection": "toolCollection",
    guide: "guide",
    "guide-category": "guideCategory",
    "how-to-cite": "howToCite",
    comparison: "comparison",
    converter: "converter",
    field: "field",
    region: "region",
    category: "category",
    "cheat-sheet": "cheatSheet",
    glossary: "glossary",
  };

export function catalogTypeLabel(
  labels: Dictionary["catalogTypes"],
  type: CatalogType
): string {
  return labels[CATALOG_TYPE_KEYS[type]];
}
